var drawerIntervenantHandles = document.querySelectorAll("[data-intervenant-drawer-container]");

drawerIntervenantHandles.forEach(drawerIntervenantHandle => {
	var drawerIntervenant = drawerIntervenantHandle?.dataset.intervenantDrawerContainer;

	if (drawerIntervenant !== undefined) {
		fetch("/pages/" + drawerIntervenant)
			.then(response => response.text())
			.then(html => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, "text/html");

				const sectionIntDescription = doc.querySelector(".intervenant-description__descriptions");
				const sectionIntInterview = doc.querySelector(".interview__content");
				const sectionIntQuote = doc.querySelector(".quote__content");

				drawerIntervenantHandle.innerHTML = ""

				if (sectionIntDescription) {
					drawerIntervenantHandle.appendChild(sectionIntDescription);
				}
				if (sectionIntInterview) {
					drawerIntervenantHandle.appendChild(sectionIntInterview);
				}
				if (sectionIntQuote) {
					drawerIntervenantHandle.appendChild(sectionIntQuote);
				}
			})
			.catch(error => {
				console.error("Erreur lors du chargement de la page:", error);
			});
	}
});


const drawer = document.querySelector('.intervenant-drawer');

if (drawer !== null && drawer !== undefined) {
	drawer.classList.add('hide');
	// Open drawer

	const btnOpenDrawer = document.querySelectorAll('[data-intervenant-open]');

	if (btnOpenDrawer.length > 0) {
		btnOpenDrawer.forEach(btn => {
			btn.addEventListener('click', (e) => {
				drawer.classList.remove('hide');
				drawer.classList.add('active');
			});
		});
	}

	// Close drawer
	const btnCloseDrawer = document.querySelectorAll('[data-intervenant-close]');

	if (btnCloseDrawer.length > 0) {
		btnCloseDrawer.forEach(btn => {
			btn.addEventListener('click', (e) => {
				drawer.classList.remove('active');
			});
		});
	}
}
